"use strict";
import { Action } from "../actions";
export default function annotationModeReducer(modes = {
  annotating: false,
  saving: false,
  loading: false,
  justSaved: false,
  showToneSliders: false,
  cropping: false
}, action) {
  let { saving, annotating, loading, justSaved, showToneSliders, cropping } = modes;
  switch (action.type) {
    case Action.SAVING_ANNOTATIONS:
      saving = true;
      justSaved = false;
      cropping = false;
      showToneSliders = false;
      break;
    case Action.SAVING_ANNOTATIONS_SUCCEEDED:
      saving = false;
      annotating = false;
      cropping = false;
      justSaved = true;
      showToneSliders = false;
      break;
    case Action.SAVING_ANNOTATIONS_FAILED:
      saving = false;
      justSaved = false;
      showToneSliders = false;
      break;
    case Action.LOADING_ANNOTATIONS:
      loading = true;
      justSaved = false;
      showToneSliders = false;
      break;
    case Action.LOADING_ANNOTATIONS_SUCCEEDED:
      loading = false;
      break;
    case Action.LOADING_ANNOTATIONS_FAILED:
      loading = false;
      break;
    case Action.TOGGLE_ANNOTATING_STATUS:
      annotating = !annotating;
      justSaved = false;
      break;
    case Action.TOGGLE_TONE_SLIDERS:
      showToneSliders = !showToneSliders;
      break;
    case Action.TOGGLE_CROPPING:
      cropping = !cropping;
      break;
    default:
      break;
  }
  return { saving, annotating, loading, justSaved, showToneSliders, cropping };
}
